export default __webpack_public_path__ + "static/media/UploadLogo.14e8e485.png";